import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AsideBarService } from '../../services/asideBar.service';
import { UiEngineComponent } from '../ui-engine/ui-engine.component';
import { ModalSize } from '../../services/smart-modal.service';

@Component({
    selector: 'app-aside-ui-engine',
    templateUrl: '../ui-engine/ui-engine.component.html',
    styleUrls: ['../ui-engine/ui-engine.component.scss'],
    standalone: false
})
export class AsideUiEngineComponent extends UiEngineComponent implements OnInit {

  constructor(public injector: Injector,
    public router: Router,
    public route: ActivatedRoute,
    public modal: BsModalService,
    public commonService: AsideBarService
  ) {
    super(injector, router, route, modal);
  }

  ngOnInit() {
    // this.communicationService.getCommonViwerData$.subscribe(data => {
    //   if(data){
    //     this.popupBeforeClose(data);
    //   }
    // });

    if (!this.parent_id) {
      this.parent_id = 0;
    }
    this.initCurrentData();
    if (this['data'] != undefined && this['data'].resource != undefined) {
      this._currentData.resource = this['data'].resource;
      this._currentData.json = this._currentData.resource;
      if(this['data'].caseSheet)
        this._currentData.casesheet = this['data'].caseSheet;
      if(this['data'].temp)
        this._currentData.temp = this['data'].temp;
    }
    this.baseService.getResourceDef(this._currentData.json, (resouceDef) => {
      if (resouceDef) {
        this._currentData.currentAction = this['data'].actionType.action_name;
        this._currentData.currentData = this['data'].data;
        this._layout_data = resouceDef;
        if(resouceDef.custom_button){
          this._currentData.buttonsListArr = resouceDef.custom_button;
        }
        this._currentData.sideFormMapping = resouceDef.side_form_mapping;
        if (this._currentData.sideFormMapping != undefined)
          this._currentData.currentData = this.commonService.processSideFormMapping(this._currentData.sideFormMapping, this._currentData.currentData);
        this.initLayoutData();
        this._currentData.customButton = this['data'].customButton != undefined ? this['data'].customButton : this._currentData.customButton;
        this._currentData.customButton = this.checkCustomButtonPermission(this._currentData.customButton);
        this._currentData.bookmarks = undefined;
        if (resouceDef.form && resouceDef.form.bookmark != undefined) {
          this._currentData.bookmarks = new Object();
          this._currentData['bookmarks']['bookmark'] = resouceDef.form.bookmark;
          this._currentData['bookmarks']['bookmark']['resource'] = resouceDef.resource;
          if (this['data'].bannerJson != undefined)
            this._currentData['bookmarks']['bannerJson'] = this['data'].bannerJson;
          else if (this._currentData.bannerJson != undefined)
            this._currentData['bookmarks']['bannerJson'] = this._currentData.bannerJson;
        }
        if (this._currentData.currentAction == 'ADD' && this['data'].setDefaultFormData)
          this._currentData.defaultFormData = this['data'].data;
        this._currentData.currentFormFields.submitButton = true;
        this.initConfigForForm(resouceDef);
      }
    });
    if (this['data'].form != undefined) {
      this._currentData.currentAction = this['data'].actionType.action_name;
      if(this['data'].caseSheet)
        this._currentData.casesheet = this['data'].caseSheet;
      if(this['data'].temp)
        this._currentData.temp = this['data'].temp;
      if (this._currentData.currentData == undefined)
        this._currentData.currentData = this['data'].data;
      this._layout_data['form'] = this['data'].form;
      this._layout_data['page_name'] = this['data'].form.page_name;
      this.initLayoutData();
      this._currentData.currentFormFields = this['data'].form;
      this._currentData.customButton = this['data'].customButton != undefined ? this['data'].customButton : {
        "Add": [
          {
            "label": "button.submit",
            "icon": "fa fa-check"
          }
        ],
        "Modify": [
          {
            "label": "button.update",
            "icon": "fa fa-check"
          }
        ]
      }
      if (this['data'].form && this['data'].form.bookmark != undefined) {
        this._currentData.bookmarks = new Object();
        this._currentData['bookmarks']['bookmark'] = this['data'].form.bookmark;
        this._currentData['bookmarks']['bookmark']['resource'] = this['data'].resource;
        if (this['data'].bannerJson != undefined)
          this._currentData['bookmarks']['bannerJson'] = this['data'].bannerJson;
        else if (this._currentData.bannerJson != undefined)
          this._currentData['bookmarks']['bannerJson'] = this._currentData.bannerJson;

        this._currentData.currentFormFields.submitButton = true;

      }
    }

    if (this['data'].decorator != undefined) {
      if (!this._currentData.decorator || (this._currentData.decorator && this._currentData.decorator.className != undefined && this._currentData.decorator.className != this['data'].decorator))
        this._currentData.decorator = this.baseService.initDecorator(this['data'].decorator, this.route, this.injector);
    }

    if (this._layout_data != undefined && this._layout_data != undefined) {
      this._layout_data.config = this._layout_data.config != undefined ? this._layout_data.config : {};
      this._layout_data.config['back_navigation'] = this._layout_data.config['back_navigation'] != undefined ? this._layout_data.config['back_navigation'] : false;
      this._layout_data.config['show_title'] = this._layout_data.config['show_title'] != undefined ? this._layout_data.config['show_title'] : false;
    }
    if (this['data'] != undefined && this['data'].actionType != undefined && this['data'].actionType.banner != undefined) {
      this._currentData.currentFormFields.bannerJson = this['data'].actionType.banner;
    }
  }
  /**
   * Checks and filters custom buttons based on user role permissions.
   * 
   * This method processes two button collections:
   * 1. buttonsListArr - Buttons defined in resource definition (resouceDef.custom_button)
   * 2. customButton - Buttons from data input or default button configuration
   * 
   * For each collection, it filters 'Add' and 'Modify' action buttons by:
   * - Checking if permission_required flag is set on each button
   * - Validating user access via rolePermissionService.checkAccessPermission()
   * - Removing buttons where permission check fails
   * 
   * This ensures only authorized buttons are displayed to users based on their
   * role-based access control (RBAC) permissions for the current resource and application.
   * 
   * @see hasButtonPermission for individual button permission logic
   * @see filterButtonsByPermission for array filtering implementation
   */
  checkCustomButtonPermission(buttonContainer: any): any {
    if (!buttonContainer) {
      console.warn('buttonContainer is undefined or null');
      return buttonContainer;
    }

    this.filterButtonsByPermission(buttonContainer, 'Add');
    this.filterButtonsByPermission(buttonContainer, 'Modify');

    // Return the updated container with filtered buttons
    return buttonContainer;
  }
  filterButtonsByPermission(buttonContainer: any, buttonType: 'Add' | 'Modify') {
    if (Array.isArray(buttonContainer?.[buttonType]) && buttonContainer[buttonType]?.length > 0) {
      buttonContainer[buttonType] = buttonContainer[buttonType].filter((el) => 
        this.hasButtonPermission(el)
      );
    }
  }

  hasButtonPermission(element: any): boolean {
    if (element?.permission_required == undefined || element?.permission_required == false) {
      return true; // Keep element if no permission check is required
    }
    
    const actionName = element?.action_name || element?.action || '';
    const permission = this.rolePermissionService.checkAccessPermission(
      actionName, 
      localStorage?.CurrentResource, 
      element?.application ?? this.appService.getApplication()
    );
    
    return permission; // Keep element if permission is true
  }
    
    /**
     * Overrides the parent `initConfigForForm` method to ensure that
     * `autoSave` and `showAddData` flags are preserved across multiple
     * invocations of the form initialization.
     *
     * Behavior:
     * - Stores existing `autoSave` and `showAddData` values before calling the parent method.
     * - Restores these values after the parent initialization, if they were previously defined.
     * - Applies overrides from the `autoSaveAndShowAddRequired` input, if provided:
     *    - Enables `autoSave` if specified.
     *    - Enables `showAddData` if specified.
     *    - Updates `formName` if provided.
     *
     * This ensures consistency of configuration flags and prevents them
     * from being reset during repeated initialization cycles.
     */
    initConfigForForm(resource_def) {
      const savedAutoSave = this._currentData?.configForm?.autoSave;
      const savedShowAddData = this._currentData?.configForm?.showAddData;

      super.initConfigForForm(resource_def);

      // Preserve flags from previous state if they existed
      if (savedAutoSave !== undefined) {
        this._currentData.configForm.autoSave = savedAutoSave;
      }
      if (savedShowAddData !== undefined) {
        this._currentData.configForm.showAddData = savedShowAddData;
      }

      // Also ensure flags from the @Input are applied
      if (this['autoSaveAndShowAddRequired']?.autoSave) {
        this._currentData.configForm.autoSave = true;
      }
      if (this['autoSaveAndShowAddRequired']?.showAddData) {
        this._currentData.configForm.showAddData = true;
      }
      if (this['autoSaveAndShowAddRequired']?.formName) {
        this._currentData['formName'] = this['autoSaveAndShowAddRequired'].formName;
      }
    }

  getDataForCurdOperation(resouceDef) {
    super.getDataForCurdOperation(resouceDef);
    if(this['data'] && this['data'].config != undefined)
      this._currentData.configForm = {...this._currentData.configForm, ... this['data'].config};
    if(this['data'].showFormData){
      this._currentData.defaultFormData = this['data'].data;
      this._currentData.configForm.showAddData = true;
    }
  }

  onSaveFinished(val) {
    val['index'] = this['data'].index != undefined ? this['data'].index : false;
    val['action'] = this['data'].actionType.action_name != undefined ? this['data'].actionType.action_name : false;
    if (this['data'].required_rowData && this['data'].data && val.result)
      val.result = { ...this['data'].data, ...val.result }

    if(val && val.action == "MODIFY" && this['data']['templateUseCase']){
      val.result = { ...this['data'].data, ...this.authenticationService.getUserType() != "patient"?{template: val.result}:val.result  }
      if(this['data'].data['tag_data']){
        val.result["tag_data"] = this['data'].data['tag_data']
      }
      if(this['data'].observation_anc_id){
        val['observation_anc_id'] = this['data']['observation_anc_id']
      }
    } 
    this.commonService.removeComponent(val, this._currentData.decorator);
  }

  onFormTab(event :any){
    this.commonService.removeComponent({case:event});
  }

  popupBeforeClose(message) {
    let buttons = { cancel: "Skip" }; let data= {};
    if(this._currentData.currentAction === 'ADD'){
      this._currentData.buttonsListArr[this._currentData.currentAction.split('').map((x,index)=>{if(index != 0){return x.toLowerCase()}else{return x}}).join("")].forEach((elem)=>{
        buttons[elem.status] = elem.label
      })
    }else if(this._currentData.currentAction === 'MODIFY'){
      this._currentData.buttonsListArr[this._currentData.currentAction.split('').map((x,index)=>{if(index != 0){return x.toLowerCase()}else{return x}}).join("")].forEach((elem)=>{
        buttons[elem.status] = elem.label
      })
    }
    const dialogRef = this.baseService.modalService.confirmCustomBtn('Save File', "Do you want to save or skip the form ", ModalSize.Sm, buttons, false,true);
    dialogRef.subscribe(result => {
      if (result == "cancel") { 
        this.commonService.removeComponent()
      }else {
        data["currentBtnVal"] = this._currentData.buttonsListArr[this._currentData.currentAction.split('').map((x,index)=>{if(index != 0){return x.toLowerCase()}else{return x}}).join("")].find(x=>x.status === result);
        data['result'] = this.formComponenet.form.getRawValue();
        this.onSaveFinished(data);
        // this.onSaveFinished(val)
      }
    })
  }

}
